import { RecordActions } from "./types";
export function addSubmittedForm(payload) {
    return {
        type: RecordActions.ADD_SUBMITTED_FORM,
        payload: payload,
    };
}
export function clearSubmittedForms(eventNumber) {
    return {
        type: RecordActions.CLEAR_SUBMITTED_FORMS,
        payload: eventNumber,
    };
}
export function addGroupId(payload) {
    return {
        type: RecordActions.ADD_GROUP_ID,
        payload: payload,
    };
}
export function addOrderId(payload) {
    return {
        type: RecordActions.ADD_ORDER_ID,
        payload: payload,
    };
}
